
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { authReducer } from './store/auth/auth.reducer';
import { AuthEffects } from './store/auth/auth.effects';
import { usersReducer } from './store/users/users.reducer';
import { UsersEffects } from './store/users/users.effects';
import { offerReducer } from './store/offer/offer.reducer';
import { OfferEffects } from './store/offer/offer.effects';
import { catalogOfferReducer } from './store/catalog-offer/catalog-offer.reducer';
import { CatalogOfferEffects } from './store/catalog-offer/catalog-offer.effects';

import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { BrowserModule } from '@angular/platform-browser';
import { MatSidenavModule } from '@angular/material/sidenav';
import { interceptorInterceptor } from './interceptors/interceptor.interceptor';
import { HttpClientModule, 
         provideHttpClient, 
         withInterceptors } from '@angular/common/http';

import { MenuModule } from './components/menu/menu.module';
import { ToolbarModule } from './components/toolbar/toolbar.module';
import { MenuUserModule } from './components/menu-user/menu-user.module';

import { UserModule } from './pages/user/user.module';
import { AreasModule } from './pages/areas/areas.module';
import { LogginModule } from './pages/loggin/loggin.module';
import { OffersModule } from './pages/offers/offers.module';
import { EmployModule } from './pages/employ/employ.module';
import { PasswordModule } from './pages/password/password.module';
import { BenefitsModule } from './pages/benefits/benefits.module';
import { ForbiddenModule } from './pages/forbidden/forbidden.module';
import { PositionsModule } from './pages/positions/positions.module';
import { ParametersModule } from './pages/parameters/parameters.module';
import { SignaturesModule } from './pages/signatures/signatures.module';
import { ResetPasswordEffects } from './store/reset-password/reset-password.effects';
import { resetPasswordReducer } from './store/reset-password/reset-password.reducer';
import { CompaniesModule } from './pages/companies/companies.module';
import { SignatureGroupEffects } from './store/signatures/signatures.effects';
import { signatureGroupReducer } from './store/signatures/signatures.reducer';
import { RequestedSignaturesModule } from './pages/requested-signatures/requested-signatures.module';
import { RequestedSignaturesEffects } from './store/signature-requested/signature-requested.effects';
import { signatureRequestedReducer } from './store/signature-requested/signature-requested.reducer';
import { BudgetCalculationModule } from './pages/budget-calculation/budget-calculation.module';
import { HolidaysModule } from './pages/holidays/holidays.module';
import { holidayGroupReducer } from './store/holidays/holidays.reducer';
import { HolidayGroupEffects } from './store/holidays/holidays.effects';
import { benefitGroupEffects } from './store/benefit-group/benefit-group.effects';
import { benefitGroupReducer } from './store/benefit-group/benefit-group.reducer';
import { ParameterGroupEffects } from './store/parameters/parameters.effects';
import { parameterGroupReducer } from './store/parameters/parameters.reducer';
import { positionReducer } from './store/position/position.reducer';
import { areaReducer } from './store/area/area.reducer';
import { divisionReducer } from './store/division/division.reducer';
import { PositionsEffects } from './store/position/position.effects';
import { AreaEffects } from './store/area/area.effects';
import { DivisionEffects } from './store/division/division.effects';
import { DivisionsModule } from './pages/divisions/divisions.module';
import { MenuEffects } from './store/menu/menu.effects';
import { menuReducer } from './store/menu/menu.reducer';
import { EmployeeEffects } from './store/employee/employee.effects';
import { employeeReducer } from './store/employee/employee.reducer';
import { BenefitCatalogModule } from './pages/benefit-catalog/benefit-catalog.module';
import { BenefitCatalogReducer } from './store/benefit-catalog/benefit-catalog.reducer';
import { BenefitCatalogEffects } from './store/benefit-catalog/benefit-catalog.effects';
import { SubscriptionsModule } from './pages/subscriptions/subscriptions.module';
import { CompanyAdminModule } from './pages/company-admin/company-admin.module';
import { companyReducer } from './store/companies/companies-reducer';
import { CompanyEffects } from './store/companies/companies-effects';
import { companiesUserReducer } from './store/companies-user/companies-user-reducer';
import { CompaniesUserEffects } from './store/companies-user/companies-user-effects';
import { WithholdingsModule } from './pages/withholdings/withholdings.module';
import { CostPerEmployeesModule } from './pages/cost-per-employees/cost-per-employees.module';
import { CostsPerEmployeeGroupEffects } from './store/cost-per-employees-group/cost-per-employee-group.effects';
import { withholdingGroupReducer } from './store/withholdings-group/withholding-group.reducer';
import { costsPerEmployeeGroupReducer } from './store/cost-per-employees-group/cost-per-employee-group.reducer';
import { WithholdingGroupEffects } from './store/withholdings-group/withholding-group.effects';
import { WithholdingCatalogModule } from './pages/withholding-catalog/withholding-catalog.module';
import { CostPerEmployeesCatalogModule } from './pages/cost-per-employee-catalog/cost-per-employees-catalog.module';
import { WithholdingCatalogReducer } from './store/withholding-catalog/withholding-catalog.reducer';
import { CostsPerEmployeeCatalogReducer } from './store/cost-per-employee-catalog/cost-per-employee-catalog.reducer';
import { WithholdingCatalogEffects } from './store/withholding-catalog/withholding-catalog.effects';
import { CostsPerEmployeeCatalogEffects } from './store/cost-per-employee-catalog/cost-per-employee-catalog.effects';
import { FormulasModule } from './pages/formulas/formulas.module';
import { formulaGroupEffects } from './store/formula-group/formula-group.effects';
import { formulaGroupReducer } from './store/formula-group/formula-group.reducer';
import { VariableCatalogModule } from './pages/variable-catalog/variable-catalog.module';
import { ObjectCatalogModule } from './pages/object-catalog/object-catalog.module';
import { ObjectCatalogEffects } from './store/object-catalog/object-catalog.effects';
import { VariableCatalogEffects } from './store/variable-catalog/variable-catalog.effects';
import { VariableCatalogReducer } from './store/variable-catalog/variable-catalog.reducer';
import { ObjectCatalogReducer } from './store/object-catalog/object-catalog.reducer';
import { OfferFormulaEvaluatorModule } from './pages/offer-formula-evaluator/offer-formula-evaluator.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    MatSidenavModule,
    HttpClientModule,
    AppRoutingModule,
    ForbiddenModule,
    PositionsModule,
    BenefitsModule,
    ToolbarModule,
  
    LogginModule,
    OffersModule,
    EmployModule,
    UserModule,
    AreasModule,
    MenuUserModule,
    MenuModule,
    ParametersModule,
    SignaturesModule,
    PasswordModule,
    CompaniesModule,
    RequestedSignaturesModule,
    BudgetCalculationModule,
    HolidaysModule,
    DivisionsModule,
    BenefitCatalogModule,
    SubscriptionsModule,
    CompanyAdminModule,
    WithholdingsModule,
    CostPerEmployeesModule,
    WithholdingCatalogModule,
    CostPerEmployeesCatalogModule,
    FormulasModule,
    VariableCatalogModule,
    ObjectCatalogModule,
    OfferFormulaEvaluatorModule,

    
    StoreModule.forRoot({
      offerRdc: offerReducer,
      authRdc: authReducer,
      catalogOfferRdc: catalogOfferReducer,
      usersRdc: usersReducer,
      resetPasswordRdc: resetPasswordReducer,
      signatureGroupRdc :signatureGroupReducer,
      offerSigReqRdc: signatureRequestedReducer,
      holidayGroupRdc: holidayGroupReducer,
      benefitGroupRdc: benefitGroupReducer,
      parameterGroupRdc: parameterGroupReducer,
      positionRdc: positionReducer,
      areaRdc: areaReducer,
      divisionRdc: divisionReducer,
      menuRdc: menuReducer,
      employeeRdc: employeeReducer,
      benefitCatalogRdc: BenefitCatalogReducer,
      companyRdc: companyReducer,
      companiesUserRdc: companiesUserReducer,
      withholdingGroupRdc: withholdingGroupReducer,
      costsPerEmployeeGroupRdc: costsPerEmployeeGroupReducer,
      costsPerEmployeeCatalogRdc: CostsPerEmployeeCatalogReducer,
      withholdingCatalogRdc: WithholdingCatalogReducer,
      formulaGroupRdc: formulaGroupReducer,
      variableCatalogRdc: VariableCatalogReducer,
      objectCatalogRdc: ObjectCatalogReducer
    }),
    EffectsModule.forRoot([
      OfferEffects, 
      AuthEffects,
      CatalogOfferEffects,
      UsersEffects,
      ResetPasswordEffects,
      SignatureGroupEffects,
      RequestedSignaturesEffects,
      HolidayGroupEffects,
      benefitGroupEffects,
      ParameterGroupEffects,
      PositionsEffects,
      AreaEffects,
      DivisionEffects,
      MenuEffects,
      EmployeeEffects,
      BenefitCatalogEffects,
      CompanyEffects,
      CompaniesUserEffects,
      WithholdingGroupEffects,
      CostsPerEmployeeGroupEffects,
      WithholdingCatalogEffects,
      CostsPerEmployeeCatalogEffects,
      formulaGroupEffects,
      ObjectCatalogEffects,
      VariableCatalogEffects

    ])
  ],
  providers: [
    provideHttpClient(
      withInterceptors([interceptorInterceptor])
    )
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }